import { useQuery } from "@tanstack/react-query";
import {
  getLeadsAffiliateEarnings,
  type AffiliateEarningsSummaryDto,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

const AFFILIATE_EARNINGS_QUERY_KEY = "AFFILIATE_EARNINGS";

export const affiliateEarningsKeys = {
  all: [AFFILIATE_EARNINGS_QUERY_KEY] as const,
};

export const useAffiliateEarningsQuery = () =>
  useQuery<AffiliateEarningsSummaryDto>({
    queryKey: affiliateEarningsKeys.all,
    queryFn: processResponseWithApiProblemDetails(() =>
      getLeadsAffiliateEarnings(),
    ),
    refetchOnWindowFocus: false,
    staleTime: MS_TIME.minute,
  });
